module.exports = __webpack_public_path__ + "img/logo.5a1f4653.jpg";